<template>
  <button class="close-button" v-on:click.prevent="close" aria-label="Schließen"></button>
</template>

<script>
export default {
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
@import "../scss/settings";
button.close-button {
  display: block !important;
  width: 24px !important;
  height: 24px !important;
  background: transparent url(/assets/images/close-icon.png) no-repeat center;
  background-size: 12px 12px;
  position: absolute;
  right: 20px;
  top: 28px;
  padding: 0;
  cursor: pointer;
  @include focus-light-outside(3px, 4px);
  @include mobile {
    top: 18px;
    right: 3px;
  }
}
</style>